class ManageLayer {
	static fromArray(data, center, list) {
		let inst = new ManageLayer(list);
		inst._id = data.id;
		inst._name = data.name;
		inst.orderBy = data.orderBy;
		inst._ownerId = data.ownerId;
		inst._ownerType = data.ownerType;
		inst._ownerName = data.ownerName;
		inst._edit = data.edit;
		inst._share = data.share;
		inst._own = data.own;
		inst.alertLevel = data.alertLevel;
		
		if (center.id == data.ownerId) inst._centerOwned = true;
		inst.onTimeline = data.orderBy > 0;

		return inst;
	}

	static blank(list) {
		let inst = new ManageLayer(list);
		inst._name = _("New Layer");
		inst._centerOwned = true;

		return inst;
	}

	constructor(list) {
		this._list = list;
		this._id = 0;
		this._name;
		this._ownerId;
		this._ownerType;
		this._ownerName;
		this._edit = true;
		this._share;
		this._own;

		this._centerOwned = false;

		this._elem = null;

		this._changeChk = UI.chk();
		onEv(this._changeChk, 'change', this.setChangeLayer.bind(this));

		this._shareBtn;
		this._editBtn;
		this._saveBtn;
		this._cancelBtn;
		this._deleteBtn;
	}

	get id() {return this._id;}
	get ownerId() { return this._ownerId; }

	get ownerMap() {
		return {
			"id": this._ownerId,
			"type": this._ownerType,
			"name": this._ownerName
		};
	}

	set orderBy(v) {
		this._orderBy = v;
	}

	set alertLevel(v) {
		this._alertLevel = v;
		this._changeChk.checked = v == 1;
	}

	get elem() {
		if (this._elem === null) {
			let editButton = null;
			if (this._centerOwned) {
				editButton = UI.priIconBtn(
					'edit', 18,
					{
						'click': this.edit.bind(this)
					},
					{
						'data-tip': 'above',
						'aria-label': _('Edit layer name')
					}
				);
			}
			let buttons = [
				layerAccess.button(this._id, this.setTimeline.bind(this)),
				UI.iconChk(this._changeChk, 'change-layer', 24)
			]

			this._elem = UI.listRow([
				UI.div('flex-1 edit-show', [
					this._nameEdit = UI.text('')
				]),
				UI.div('flex-1 edit-hide flex items-center gap-1', [
					this._nameView = UI.span('', this.name),
					editButton
				]),
				UI.div('flex-0 edit-show', [
					UI.btn('ps-2', _("SAVE"), { 'click': this.save.bind(this) }),
					UI.btn('ps-2', _("CANCEL"), { 'click': this.cancel.bind(this) })
				]),
				UI.div('flex-0 edit-hide', [
					buttons
				])
			]);
		}

		this.update();
		return this._elem;
	}
	
	get name() {
		return this._centerOwned ? this._name : `${this._name} (${this._ownerName})`;
	}

	setTimeline(accessCount) {
		if (accessCount && this.onTimeline) return;
		if (!accessCount && !this.onTimeline) return;
		
		this.onTimeline = accessCount > 0;
		API.upsert(
			`timelines/${this._list.timeline}/layers`,
			this.id,
			{
				selected: this.onTimeline
			}
		)
		.then(reply => {
			showError(reply);
		});
		this.update();
	}

	setChangeLayer() {
		API.upsert(
			`timelines/${this._list.timeline}/layers`,
			this.id,
			{
				changeLayer: (this._changeChk.checked ? 1 : 0)
			}
		)
		.then(reply => {
			showError(reply);
		});
	}

	edit() {
		if (this._list._activeLayer) return;
		this._list._activeLayer = this;
		this._nameEdit.value = this._name;
		Dialog.Inline(this._elem, this);
		this._nameEdit.select();
	}

	save() {
		if (this._nameEdit.value.length) this._name = this._nameEdit.value;
		this._nameView.innerHTML = this._name;

		API.upsert(
			`timelines/${this._list.timeline}/layers`,
			this._id,
			{
				name: this._name
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			if (reply.id) {
				layerAccess.updateButtonId(this._id, reply.id);
				layerSharing.updateButtonId(this._id, reply.id);
				this._id = reply.id;
			}
			this.finish();
		});
	}
	
	cancel() {
		this.finish();
		if (this.id === 0) this._list.remove(this);
	}

	finish() {
		Dialog.Inline(this._elem);
		this._list._activeLayer = null;
	}

	delete() {
		Dialog.Confirm(
			_('This will delete the layer and all events. This will affect anyone the layer is shared with. <br/>This cannot be undone!'),
			_('DELETE LAYER'),
			() => {
				API.delete(
					`layers/${this.id}`
				) 
				.then(reply => {
					if (showError(reply)) return;
					this.elem.remove();
				});
			}
		);
	}

	update() {
		this._nameView.className = '';
	}
}